
export const defaultInfo = {}

export const defaultLoading = null

export const defaultError = null

export const defaultIframeLoaded = false

export default {
  info: defaultInfo,
  loading: defaultLoading,
  error: defaultError,
  iframeLoaded: defaultIframeLoaded
}
